// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__shVBB","login":"Header_login__hpQNj","login_txt":"Header_login_txt__8agQ8","line":"Header_line__vI3iU"};